import Icon from '../Icon/Icon';
import React, { useRef, useState } from 'react';
import Tooltip, { TooltipPosition } from '../Tooltip/Tooltip';
import styles from './IconButton.module.scss';
import PropTypes from 'prop-types';
import * as propTypes from 'prop-types';

const Button = ({ icon, tooltip, onClick }) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const buttonRef = useRef(null);

    const computedIcon = icon ? React.createElement(Icon[icon]) : null;

    return (
        <div
            ref={buttonRef}
            className={styles.IconButton}
            onClick={onClick}
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
        >
            {computedIcon}
            {tooltip && (
                <Tooltip
                    visible={showTooltip}
                    element={buttonRef.current}
                    position={TooltipPosition.TOP_RIGHT}
                    className={styles.Tooltip}
                >
                    {tooltip}
                </Tooltip>
            )}
        </div>
    );
};

Button.propTypes = {
    icon: propTypes.string,
    tooltip: PropTypes.string,
    onClick: PropTypes.func,
    tooltipPosition: PropTypes.string,
    className: PropTypes.string,
};

export default Button;
